var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 162,
    fill: "none",
    viewBox: "0 0 161 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#organization-placeholder_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.75,
    cy: 82.25,
    r: 75.5,
    fill: "#fff",
    stroke: "#3636D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#organization-placeholder_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3636D8",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.617,
    d: "M120.967 124.166h-2.525v-79.29a1.513 1.513 0 0 0-1.511-1.511H88.649a1.51 1.51 0 0 0-1.518 1.51v6.57h-3.029v-6.57a1.51 1.51 0 0 0-1.518-1.474h-6.561v-4.583a1.519 1.519 0 1 0-3.029 0V43.4h-6.568a1.51 1.51 0 0 0-1.511 1.51v6.569h-4.547a1.513 1.513 0 0 0-1.518 1.518V65.58H46.224a1.52 1.52 0 0 0-1.511 1.518v57.067h-2.526a1.52 1.52 0 0 0-1.518 1.518 1.52 1.52 0 0 0 1.519 1.518h78.779a1.516 1.516 0 0 0 1.518-1.518 1.52 1.52 0 0 0-1.518-1.518ZM67.944 46.394h13.13v5.036h-13.13zm-2.022 77.772H47.763V68.617h25.253v55.549zm35.354 0H76.023V86.798h25.253zm14.137 0h-11.109V83.258a1.516 1.516 0 0 0-1.514-1.414 1.517 1.517 0 0 0-1.514 1.414v.51h-3.03v-.51a1.518 1.518 0 1 0-3.035 0v.51h-5.037V46.395h25.217v77.772h.022Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#organization-placeholder_svg__c)",
    d: "M74.505 65.58H61.878V54.474h25.253V83.77H76.023v-5.037h4.547a1.518 1.518 0 0 0 0-3.036h-4.547V70.66h4.547a1.518 1.518 0 0 0 0-3.029h-4.547v-.503a1.517 1.517 0 0 0-1.518-1.547Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3636D8",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.617,
    d: "M82.584 121.135a1.5 1.5 0 0 0 1.073-.44 1.5 1.5 0 0 0 .445-1.07V91.343a1.519 1.519 0 1 0-3.029 0v28.318a1.51 1.51 0 0 0 1.511 1.474Zm6.066 0a1.51 1.51 0 0 0 1.51-1.51V91.343a1.519 1.519 0 1 0-3.029 0v28.318a1.51 1.51 0 0 0 1.518 1.474Zm6.057 0a1.52 1.52 0 0 0 1.518-1.51V91.343a1.517 1.517 0 1 0-3.029 0v28.318a1.51 1.51 0 0 0 1.51 1.474Zm2.021-64.641a1.52 1.52 0 0 0 1.519-1.518V52.96a1.518 1.518 0 1 0-3.037 0v2.015a1.52 1.52 0 0 0 1.519 1.518Zm6.058-.001a1.5 1.5 0 0 0 1.076-.443 1.5 1.5 0 0 0 .442-1.075V52.96a1.516 1.516 0 0 0-2.624-1.14 1.53 1.53 0 0 0-.404 1.14v2.015a1.5 1.5 0 0 0 .44 1.073 1.5 1.5 0 0 0 1.07.445Zm6.065 0a1.51 1.51 0 0 0 1.398-.938 1.5 1.5 0 0 0 .113-.58V52.96a1.517 1.517 0 1 0-3.029 0v2.015a1.51 1.51 0 0 0 1.518 1.518ZM96.728 66.595a1.52 1.52 0 0 0 1.519-1.518v-2.022a1.518 1.518 0 1 0-3.037 0v2.022a1.52 1.52 0 0 0 1.519 1.518Zm6.058-.001a1.51 1.51 0 0 0 1.518-1.518v-2.022a1.516 1.516 0 0 0-2.55-1.005 1.52 1.52 0 0 0-.479 1.005v2.022a1.52 1.52 0 0 0 .44 1.073 1.53 1.53 0 0 0 1.071.445Zm6.065 0a1.51 1.51 0 0 0 1.511-1.518v-2.022a1.516 1.516 0 0 0-2.55-1.005 1.52 1.52 0 0 0-.479 1.005v2.022a1.51 1.51 0 0 0 1.518 1.518ZM96.728 76.696a1.52 1.52 0 0 0 1.519-1.518v-2.021a1.518 1.518 0 1 0-3.037 0v2.021a1.52 1.52 0 0 0 1.519 1.518Zm6.058-.001a1.5 1.5 0 0 0 1.076-.442 1.52 1.52 0 0 0 .442-1.076v-2.021a1.516 1.516 0 0 0-2.55-1.006 1.52 1.52 0 0 0-.479 1.006v2.021a1.52 1.52 0 0 0 .44 1.073 1.53 1.53 0 0 0 1.071.445Zm6.065 0a1.51 1.51 0 0 0 1.511-1.518v-2.021a1.516 1.516 0 0 0-2.55-1.006 1.52 1.52 0 0 0-.479 1.006v2.021a1.51 1.51 0 0 0 1.518 1.518Zm-54.548 4.038a1.51 1.51 0 0 0 1.518-1.511v-2.007a1.518 1.518 0 1 0-3.022 0v2.021a1.51 1.51 0 0 0 1.504 1.497Zm6.065-.001a1.51 1.51 0 0 0 1.51-1.51v-2.008a1.519 1.519 0 1 0-3.028 0v2.022a1.51 1.51 0 0 0 1.518 1.496Zm6.057-.001a1.52 1.52 0 0 0 1.518-1.51v-2.008a1.518 1.518 0 1 0-3.036 0v2.022a1.52 1.52 0 0 0 1.518 1.496ZM54.303 90.834a1.51 1.51 0 0 0 1.518-1.511v-2.036a1.517 1.517 0 1 0-3.022 0v2.021a1.51 1.51 0 0 0 1.504 1.526Zm6.065-.001a1.51 1.51 0 0 0 1.51-1.51v-2.036a1.52 1.52 0 1 0-3.028 0v2.021a1.51 1.51 0 0 0 1.518 1.525Zm6.057-.001a1.52 1.52 0 0 0 1.518-1.51v-2.036a1.518 1.518 0 1 0-3.036 0v2.021a1.52 1.52 0 0 0 1.518 1.525Zm-12.122 10.124a1.52 1.52 0 0 0 1.073-.44 1.52 1.52 0 0 0 .445-1.071v-2.022a1.519 1.519 0 1 0-3.03 0v2.022a1.51 1.51 0 0 0 1.512 1.511Zm6.065 0a1.51 1.51 0 0 0 1.51-1.511v-2.022a1.519 1.519 0 1 0-3.028 0v2.022a1.513 1.513 0 0 0 1.518 1.511Zm6.057-.001a1.52 1.52 0 0 0 1.518-1.511v-2.022a1.518 1.518 0 1 0-3.036 0v2.022a1.52 1.52 0 0 0 1.518 1.511Zm-12.122 10.072a1.52 1.52 0 0 0 1.073-.44 1.53 1.53 0 0 0 .445-1.071v-2.015a1.519 1.519 0 1 0-3.03 0v2.022a1.513 1.513 0 0 0 1.512 1.504Zm6.065 0a1.513 1.513 0 0 0 1.51-1.511v-2.015a1.52 1.52 0 1 0-3.028 0v2.022a1.514 1.514 0 0 0 1.518 1.504Zm6.057.001a1.52 1.52 0 0 0 1.518-1.511v-2.015a1.519 1.519 0 0 0-3.036 0v2.022a1.517 1.517 0 0 0 1.518 1.504Zm-12.122 8.633a1.517 1.517 0 0 0 1.518-1.518v-2.079a1.519 1.519 0 0 0-3.022 0v2.021a1.52 1.52 0 0 0 .914 1.451c.186.081.387.123.59.125Zm6.065 0a1.516 1.516 0 0 0 1.51-1.518v-2.079a1.516 1.516 0 0 0-1.514-1.414 1.516 1.516 0 0 0-1.514 1.414v2.022a1.517 1.517 0 0 0 1.518 1.575Zm6.058.001a1.523 1.523 0 0 0 1.518-1.518v-2.079a1.515 1.515 0 0 0-1.518-1.518 1.517 1.517 0 0 0-1.518 1.518v2.022a1.524 1.524 0 0 0 1.518 1.575Zm42.425-32.865a1.51 1.51 0 0 0 1.511-1.518v-2.022a1.515 1.515 0 0 0-1.514-1.413 1.517 1.517 0 0 0-1.515 1.413v2.022a1.51 1.51 0 0 0 1.518 1.518Zm0 10.102a1.517 1.517 0 0 0 1.511-1.519v-2.02a1.516 1.516 0 0 0-2.55-1.005 1.52 1.52 0 0 0-.479 1.005v2.022a1.517 1.517 0 0 0 1.518 1.518Zm0 10.099a1.515 1.515 0 0 0 1.511-1.518v-2.021a1.518 1.518 0 0 0-3.029 0v2.021a1.52 1.52 0 0 0 1.518 1.518Zm0 10.102a1.52 1.52 0 0 0 1.511-1.518v-2.022a1.519 1.519 0 0 0-3.029 0v2.022a1.52 1.52 0 0 0 1.518 1.518Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3636D8",
    d: "M82.08 61.041a1.51 1.51 0 0 0-1.51-1.518H68.447a1.517 1.517 0 1 0 0 3.029H80.57a1.51 1.51 0 0 0 1.51-1.51Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "organization-placeholder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h161v161H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "organization-placeholder_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.26 36h82.633v92.5H40.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "organization-placeholder_svg__c",
    x1: 61.878,
    x2: 87.131,
    y1: 69.121,
    y2: 69.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7AFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00EDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00EEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00EEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#00EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#00E0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#14AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#429AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#658EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8F80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#947EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationPlaceholder);
export default __webpack_public_path__ + "static/media/organization-placeholder.33d74f8848d9e4e1c12f1bd59d431a5f.svg";
export { ForwardRef as ReactComponent };